import { MESSAGES } from '../const';
import { getFileType } from './get-file-type';

export const filesFormatValidator = (files = {}, format = 'File') => {
  if (
    Object.values(files).every(
      (file: any) => getFileType(file.name).toLocaleUpperCase() === format.toLocaleUpperCase(),
    )
  )
    return;

  return Object.values(files)
    .filter(
      (file: any) => getFileType(file.name).toLocaleUpperCase() !== format.toLocaleUpperCase(),
    )
    .map((file: any) => MESSAGES.FILE.FORMAT_NOT_VALID(file.name))
    .join('\n');
};
